import { jwtDecode, JwtPayload } from "jwt-decode";
import wpFetch from "./wpFetch";
import { ApiKeyProvider } from "./ApiKeyProvider";

export class JwtHandler implements ApiKeyProvider {
	private cachedJwt: string = "";
	private cachedJwtExp: number | null = null;
	private cachedNonce: string;
	private promise: Promise<string | null> | null = null;

	constructor(nonce: string) {
		this.cachedNonce = nonce;
	}

	private set(jwt: string) {
		this.cachedJwt = jwt;
		this.cachedJwtExp = this.extractJwtExpire(jwt);
	}

	async get(captcha?: string): Promise<string | null> {
		if (this.isValid) return this.cachedJwt;

		if (!this.promise) this.promise = this.fetch(captcha);

		return this.promise;
	}

	private async fetch(captcha?: string): Promise<string> {
		const urlParams = new URLSearchParams();
		if (this.cachedJwt?.length) urlParams.append("jwt", this.cachedJwt);
		if (captcha?.length) urlParams.append("captcha", captcha);
		const url = ["jwt", urlParams.toString()].join("?");

		console.log(`jwtHandler fetching ${url}…`);

		try {
			const { jwt, nonce } = await wpFetch(url, this.cachedNonce);
			console.log(`Fetched new JWT (${jwt}) and nonce (${nonce}).`);

			this.set(jwt);
			this.cachedNonce = nonce;
			this.promise = null;

			return jwt;
		} catch (error) {
			this.promise = null;

			console.log("FETCH ERROR");
			console.dir(error);
			throw error;
		}
	}

	setFromCookie(cookies: Record<string, string>, prefix: string): void {
		const cookieJwt = cookies[`${prefix}__jwt`];
		if (cookieJwt) this.set(cookieJwt);
	}

	validate(token: string): boolean {
		try {
			const decoded: JwtPayload = jwtDecode<JwtPayload>(token);
			return decoded.exp! > Date.now() / 1000;
		} catch {
			return false;
		}
	}

	extractJwtExpire(token: string): number {
		try {
			const decoded: JwtPayload = jwtDecode<JwtPayload>(token);
			return decoded.exp!;
		} catch {
			return 0;
		}
	}

	get jwtExp() {
		return this.cachedJwtExp;
	}

	get nonce() {
		return this.cachedNonce;
	}

	get isValid(): boolean {
		return this.cachedJwt ? this.validate(this.cachedJwt) : false;
	}
}
